export interface AdSlotOptions {
  client: string;
  slot: string;
}

const SLOT_ID = 'web-ad-slot';
let scriptRequested = false;

function loadAdsScript(client: string): Promise<void> {
  return new Promise((resolve) => {
    if (scriptRequested || typeof document === 'undefined') {
      resolve();
      return;
    }
    scriptRequested = true;
    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });
}

export async function showWebAdSlot(options: AdSlotOptions): Promise<boolean> {
  if (typeof document === 'undefined' || !options.client || !options.slot) {
    return false;
  }
  await loadAdsScript(options.client);
  hideWebAdSlot();
  const container = document.createElement('div');
  container.id = SLOT_ID;
  const ins = document.createElement('ins');
  ins.className = 'adsbygoogle';
  ins.style.display = 'block';
  ins.setAttribute('data-ad-client', options.client);
  ins.setAttribute('data-ad-slot', options.slot);
  ins.setAttribute('data-ad-format', 'auto');
  ins.setAttribute('data-full-width-responsive', 'true');
  container.appendChild(ins);
  document.body.appendChild(container);
  document.body.classList.add('has-ad-slot');
  try {
    const ads = (window as unknown as { adsbygoogle?: unknown[] }).adsbygoogle ?? [];
    ads.push({});
    (window as unknown as { adsbygoogle?: unknown[] }).adsbygoogle = ads;
  } catch {
    return true;
  }
  return true;
}

export function hideWebAdSlot(): void {
  if (typeof document === 'undefined') {
    return;
  }
  const existing = document.getElementById(SLOT_ID);
  if (existing) {
    existing.remove();
  }
  document.body.classList.remove('has-ad-slot');
}
